const ELEMENTS = {
  CONTENT: document.documentElement,
  VIDEO: document.getElementById("video-id"),
  LOGO: document.getElementById("video-logo"),
  VIDEO_WRAPPER: document.querySelector(".video-splash"),
}

if (ELEMENTS.VIDEO) {
  if (sessionStorage.getItem("playedIntroVideo") === "true") {
    // Do whatever you need to do to when not playing the video...(maybe nothing)
    ELEMENTS.VIDEO_WRAPPER.remove()
  } else {
    ELEMENTS.VIDEO.addEventListener("loadedmetadata", () => {
      const duration = ELEMENTS.VIDEO.duration * 1000;

      if (duration) {
        setTimeout(function() {
          ELEMENTS.LOGO.classList.add("logo-reveal");
        }, duration - 1250);
      }
    })

    ELEMENTS.VIDEO.addEventListener("ended", () => {
      ELEMENTS.LOGO.classList.add("logo-reveal");

      // set the cookie and set the var to true once it's been played
      sessionStorage.setItem("playedIntroVideo", "true")

      setTimeout(function() {
        ELEMENTS.CONTENT.classList.add("intro-anim")
        ELEMENTS.CONTENT.classList.remove("intro-ready")

        ELEMENTS.VIDEO_WRAPPER.addEventListener("transitionend", () => {
          ELEMENTS.VIDEO_WRAPPER.remove()
        });
      }, 700);
    })

    // Show the video code goes here...
    ELEMENTS.CONTENT.classList.add("intro-ready")
  }
}
